const filePath = `${process.env.PUBLIC_URL}/AppProps.json`;
var serverUrl = "https://hr-api.infiheal.com/";
var res1 = await fetch(`${filePath}`, {
  method: "GET",
});
var data = await res1.json();
serverUrl = data["server"];

export default serverUrl;